var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Bold/Vector",
    d: "M13.6313 4.27533H3.07568",
    stroke: "#EE203D",
    strokeWidth: 1.4394,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Bold/Vector_2",
    d: "M6.91406 6.91423V10.7526",
    stroke: "#EE203D",
    strokeWidth: 1.4394,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Bold/Vector_3",
    d: "M9.79297 6.91423V10.7526",
    stroke: "#EE203D",
    strokeWidth: 1.4394,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Bold/Vector_4",
    d: "M12.6715 4.27533V13.1516C12.6715 13.2789 12.621 13.4009 12.531 13.4909C12.441 13.5809 12.319 13.6314 12.1917 13.6314H4.51496C4.3877 13.6314 4.26567 13.5809 4.17569 13.4909C4.08571 13.4009 4.03516 13.2789 4.03516 13.1516V4.27533",
    stroke: "#EE203D",
    strokeWidth: 1.4394,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x92\x9C Icon/Bold/Vector_5",
    d: "M10.7526 4.27534V2.83594C10.7526 2.58144 10.6515 2.33736 10.4715 2.1574C10.2916 1.97744 10.0475 1.87634 9.79298 1.87634H6.91419C6.65969 1.87634 6.41561 1.97744 6.23565 2.1574C6.05569 2.33736 5.95459 2.58144 5.95459 2.83594V4.27534",
    stroke: "#EE203D",
    strokeWidth: 1.4394,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.3f4f79220355248309213f86caf0c73d.svg";
export { ForwardRef as ReactComponent };